<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc1"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/part01">P<span class="small">ART</span> I: A<span class="small">NSWERING THE</span> C<span class="small">ALL</span>: T<span class="small">HOSE</span> W<span class="small">HO</span> V<span class="small">OLUNTEERED</span></a></p>
<p class="toc"><a href="#/chapter01">1. Initial Reaction to the Outbreak of the Civil War</a></p>
<p class="toc"><a href="#/chapter02">2. The Thirty-third New York Volunteers</a></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Camp Swift: Geneva’s Civil War Mobilization Camp</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. The 126<sup>th</sup> New York Volunteers</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. The 148<sup>th</sup> New York Volunteers</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Other Regiments in Which Seneca County Men Served</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Medal of Honor Recipients from Seneca County</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Some Seneca County Men Who Served</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. John L. Hoster: Adventures of a Civil War Soldier</span></p>
<p class="toc1"><span href="#/part02" title="Link target outside of Sample">P<span class="small">ART</span> II: T<span class="small">HE</span> H<span class="small">OMEFRONT</span>: C<span class="small">OPING AND</span> T<span class="small">HRIVING</span></span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. The Civil War Was a Tremendous Boost to Seneca County Industries and Farms</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Coping with the Realities of a Prolonged War</span></p>
<p class="toc1"><span href="#/part03" title="Link target outside of Sample">P<span class="small">ART</span> III: L<span class="small">EST</span> W<span class="small">E</span> F<span class="small">ORGET</span>: P<span class="small">RESERVING THE</span> L<span class="small">EGACY</span></span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Waterloo: Birthplace of Memorial Day</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. The Scythe Tree Story</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. Civil War Monuments and Memorials in Seneca County</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">15. GAR Posts and Affiliated and Successor Organizations in Seneca County</span></p>
<p class="toc1"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?191b0c33